import { render, staticRenderFns } from "./LayoutGridSystem.vue?vue&type=template&id=afdc2df6&scoped=true&"
import script from "./LayoutGridSystem.vue?vue&type=script&lang=js&"
export * from "./LayoutGridSystem.vue?vue&type=script&lang=js&"
import style0 from "./LayoutGridSystem.vue?vue&type=style&index=0&id=afdc2df6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdc2df6",
  null
  
)

export default component.exports